import { makeStyles, shorthands } from "@fluentui/react-components";
import DOMPurify from "dompurify";
import parse from "html-react-parser";
import * as React from "react";

const useStyles = makeStyles({
  root: {
    paddingLeft: "30px",
    fontSize: "1rem",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
    ...shorthands.margin(0),
  },
});

const allowedHtmlTags = [
  "p",
  "b",
  "s",
  "ul",
  "li",
  "ol",
  "span",
  "a",
  "table",
  "tr",
  "td",
  "th",
  "br",
];

type Props = {
  content: string;
};

export const FaqBody: React.FC<Props> = ({ content }) => {
  const sanitizedHtml = DOMPurify.sanitize(content, {
    IN_PLACE: true,
    ALLOWED_TAGS: allowedHtmlTags,
  });
  const sanitizedContent = parse(sanitizedHtml);
  const styles = useStyles();

  return <div className={styles.root}>{sanitizedContent}</div>;
};
